export default {"src":"/_next/static/media/user.b47b689d.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};